export const GET_FLOW = 'GET_FLOW'
export const GET_FLOW_EXITO = 'GET_FLOW_EXITO'
export const GET_FLOW_ERROR = 'GET_FLOW_ERROR'
